const Indicators = "indicators/";
const Boundary = "boundary/";

const ApiUrl = {
  Login: "users/login/",

  // Indicators
  Indicators,
  IndicatorCategories: `${Indicators}categories/`,
  IndicatorDownload: `${Indicators}download/`,
  IndicatorSubCategories: `${Indicators}subcategories/`,
  LastUpdated: `${Boundary}last_updated/`,
  kbCollect: `${Indicators}api/kb-collect/`,

  // Boundary
  CountryBoundary: `${Boundary}countries/`,
  ZoneBoundary: `${Boundary}zones/`,
  StateBoundary: `${Boundary}states/`,
  LgaBoundary: `${Boundary}lgas/`,
  WardBoundary: `${Boundary}wards/`,
  FacilityBoundary: `${Boundary}facility/`,
  FeedBack: `${Boundary}feedbacks/`,
  QueryPhc : `${Boundary}query-phc/`,
  Revitalization: "revitalization/",
};

const enum ApiKeys {
  LOGIN = "login",
  INDICATORS = "indicators",
  INDICATORS_CATEGORY = "indicatorsCategory",
  INDICATORS_SUBCATEGORY = "indicatorsSubCategory",
  INDICATORS_DOWNLOAD = "indicatorsDownload",
  COUNTRY_BOUNDARY = "countryBoundary",
  STATE_BOUNDARY = "stateBoundary",
  LGA_BOUNDARY = "lgaBoundary",
  WARD_BOUNDARY = "wardBoundary",
  FACILITY_BOUNDARY = "facilityBoundary",
  FEEDBACK = "feedback",
  QUERY_PHC = "queryPhc",
}

export { ApiKeys, ApiUrl };

